import React from "react";
import PageBody from "Common/Custom/PageBody";
import AddItemBtn from "Common/Custom/AddItemBtn";
import { HeadingOne } from "Common/Custom/HeadingOne";
import CandidateInterviewListTable from "./components/CandidateInterviewListTable";

const CandidateInterviewList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Candidate Interview List</HeadingOne>
                    <AddItemBtn url="add-candidate-interview" title="Create" />
                </>
            }
        >
            <div className="col-12">
                <CandidateInterviewListTable />
            </div>
        </PageBody>
    );
};

export default CandidateInterviewList;
